import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"];
import { useQuery } from 'data-fetching-client';
import { GET_IS_CONNECTED_CONTACT } from '../data/queries';
import { captureException } from '../utils/captureException';
export function useGetIsConnectedContact(contactId, options = {}) {
  var _data$isConnectedCont;
  const _useQuery = useQuery(GET_IS_CONNECTED_CONTACT, Object.assign({}, options, {
      variables: {
        contactId
      },
      onError: err => {
        var _options$onError;
        captureException(err, ['useGetIsConnectedContact']);
        (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, err);
      }
    })),
    {
      data
    } = _useQuery,
    queryResult = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  return Object.assign({
    isConnectedContact: (_data$isConnectedCont = data === null || data === void 0 ? void 0 : data.isConnectedContact.isConnectedContact) !== null && _data$isConnectedCont !== void 0 ? _data$isConnectedCont : false
  }, queryResult);
}